<template>
  <v-ons-page id="search_page" :class="{'show': isPageShow}">
    <div id="search">
      <Header :pageType="'search'"></Header>
      <div id="content">
        <div class="notice">
          <dl v-accordion>
            <dt class="open"><span>ATMコーナーのご利用に関するご案内</span></dt>
            <dd>
              <div class="notice_inner">
                <span>
                  商業施設等の休業や営業時間短縮などにより、弊行ATMがご利用いただけない場合がございます。
                </span>
                <!-- <div class="center">
                  <a href="#" target="_blank" class="orange_border_button _blank">ご相談はこちらから</a>
                </div> -->
              </div>
            </dd>
          </dl>
        </div>

        <div class="search_area">
          <div class="kv">
            <img src="../assets/images/top/kv_pc.png" alt="店舗・ATM検索" class="sp_none">
            <img src="../assets/images/top/kv_sp.png" alt="店舗・ATM検索" class="pc_none">
            <h1>店舗・ATM検索</h1>
            <div class="search">
              <div class="search_functions">
                <button type="button" class="square_button search_button orange_gradation" @click="pushMap(3)">
                  <span> <img class="button_gps" src="../assets/images/top/gps.svg"/>現在地から探す</span>
                </button>
                <div class="search_text">
                  <!-- SP -->

                  <div class="search_text_left">
                    <span class="sp_none">キーワード</span>
                   <div class="left_search" @click="pushSerchArea()">
                    <button type="button" class="pc_none">エリア</button>
                  </div>
                    <Suggest :pageType="'search'" @suggests="getSuggests($event)" @inputName="getInputName($event)"></Suggest>
                  </div>
                  <div class="search_text_right">

                    <!-- PC -->
                    <div class="right_search" @click="pushSerchArea()">
                      <button type="button" class="sp_none">エリアから探す</button>
                    </div>
                    <div class="right_search" @click="liftGrepSearch()">
                      <button type="button" class="sp_none">条件を絞り込む</button>
                    </div>
                    <div class="right_search search_icon">
                      <button type="button" @click="pushSearchResultMap()"></button>
                    </div>

                  </div>
                </div>
                <div class="search_more pc_none" @click="liftGrepSearch()">
                  <span>条件を絞り込む</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="top_articles">
          <div class="use_atm">
            <h2 class="underline_orange">
              ATMのご利用について
              <span></span>
            </h2>
            <div class="atm_infos">
              <a href="https://www.ncbank.co.jp/kinri_tesuryo/atm/teikei/riyojikan_tesuryo.html?_ga=2.30257590.823947327.1617598386-189808804.1578631735" class="square_button --shadow_hover" v-ripple><span>ATM利用可能時間・手数料</span></a>
              <a href="https://www.ncbank.co.jp/oshirase/atm_riyo_gendogaku/?_ga=2.30257590.823947327.1617598386-189808804.1578631735" class="square_button --shadow_hover" v-ripple><span>ATM利用限度額</span></a>
              <a href="https://www.ncbank.co.jp/tenpo_atm/takino_atm/?_ga=2.30257590.823947327.1617598386-189808804.1578631735" class="square_button --shadow_hover" v-ripple><span>ATMの便利な機能</span></a>
              <a href="https://faq.ncbank.co.jp/faq_list.html?page=1&category=49" class="square_button --shadow_hover" v-ripple><span>よくあるご質問</span></a>
              <a href="https://www.ncbank.co.jp/otoiawase/?_ga=2.30257590.823947327.1617598386-189808804.1578631735#atm_ib" class="square_button --shadow_hover" v-ripple><span>ATMに関する<br>お問い合わせ</span></a>
            </div>
          </div>
          <div class="convenience_atm">
            <h2 class="underline_orange">
              コンビニATM
              <span></span>
            </h2>
            <ul class="convenience_banners">
              <li class="seven_bank --shadow_hover">
                <a href="https://www.sevenbank.co.jp/" class="convenience_banners_inner" v-ripple>
                  <img src="../assets/images/top/sevenbank_logo_pc.svg" alt="セブン銀行" class="sp_none">
                  <img src="../assets/images/top/sevenbank_logo_sp.svg" alt="セブン銀行" class="pc_none">
                </a>
              </li>
              <li class="lawson_atm --shadow_hover">
                <a href="https://www.lawsonbank.jp/atm/" class="convenience_banners_inner" v-ripple>
                  <img src="../assets/images/top/lawsonatm_logo_pc.svg" alt="ローソンATM" class="sp_none">
                  <img src="../assets/images/top/lawsonatm_logo_sp.svg" alt="ローソンATM" class="pc_none">
                </a>
              </li>
              <li class="e_net --shadow_hover">
                <a href="https://www.enetcom.co.jp/" class="convenience_banners_inner" v-ripple>
                  <img src="../assets/images/top/enet_logo_pc.svg" alt="E-net" class="sp_none">
                  <img src="../assets/images/top/enet_logo_sp.svg" alt="E-net" class="pc_none">
                </a>
              </li>
            </ul>
          </div>
          <div class="atm_service">
            <h2 class="underline_orange">
              ATMサービス
              <span></span>
            </h2>
            <div  class="atms">
              <a href="https://www.ncbank.co.jp/tenpo_atm/atm_teikei_cash/" class="kyusyu_atm_network --shadow_hover" v-ripple>
                <img src="../assets/images/top/service_kyusyu_atm_network_pc.svg" alt="九州ATMネットワーク" class="sp_none">
                <img src="../assets/images/top/service_kyusyu_atm_network_sp.svg" alt="九州ATMネットワーク" class="pc_none">
              </a>
              <a href="https://www.ncbank.co.jp/tenpo_atm/teikei/yubin_kyoku.html" class="japanpost --shadow_hover" v-ripple>
                <div>
                  <img src="../assets/images/top/service_japanpost_pc.svg" alt="ゆうちょ銀行とのATM相互連携" class="sp_none">
                  <img src="../assets/images/top/service_japanpost_sp.svg" alt="ゆうちょ銀行とのATM相互連携" class="pc_none">
                  <span>ゆうちょ銀行とのATM相互提携</span>
                </div>
              </a>
              <a href="https://www.ncbank.co.jp/tenpo_atm/teikei/credit.html" class="credit --shadow_hover" v-ripple>
                <div>
                  <img src="../assets/images/top/service_credit_pc.svg" alt="キャッシング提携先" class="sp_none">
                  <img src="../assets/images/top/service_credit_sp.svg" alt="キャッシング提携先" class="pc_none">
                  <span>キャッシング提携先</span>
                </div>
              </a>
            </div>
          </div>
          <div class="list_download">
            <h2 class="underline_orange">
              店舗・ATMリスト
              <span></span>
            </h2>
            <div class="download_links">
              <a :href="excel.url" target="_blank" class="square_button --shadow_hover column" v-ripple>
              <!-- <a href="https://www2.ncbank.co.jp/atm/data/ATM20211130.xls" target="_blank" class="square_button --shadow_hover column" v-ripple> -->
                <span>一覧を開く（PDF）</span>
                <span class="update_now">&lt;{{excel.date}}現在&gt;</span>
              </a>
              <a href="http://www.ncbank.co.jp/oshirase/tempo_tohaigo/index.html?_ga=2.181531630.877655798.1640154817-1624690786.1634090021" class="square_button --shadow_hover" v-ripple>
                <span>統廃合店舗</span>
              </a>
            </div>
          </div>
          <div class="sp_none download-pc">
              <img class="banner" src="../assets/images/top/bn-area-pc.svg">
              <div class="store_link">
                <div class="right-border">
                  <p class="title">iPhoneの方</p>
                  <p>
                    <a href="https://apps.apple.com/app/apple-store/id969507478?pt=117693501&ct=tenpoatmHP_tenpoatmHP&mt=8"><img  src="../assets/images/top/appstore-pc.svg"></a>
                    <a href="https://apps.apple.com/app/apple-store/id969507478?pt=117693501&ct=tenpoatmHP_tenpoatmHP&mt=8"><img src="../assets/images/top/appstore-qr.svg"></a>
                  </p>
                </div>
                <div >
                  <p class="title">Androidの方</p>
                  <p>
                    <a href="https://play.google.com/store/apps/details?id=jp.co.ncbank.bankingappli&referrer=utm_source%3DtenpoatmH%26utm_campaign%3DtenpoatmHP"><img src="../assets/images/top/googleplay-pc.svg"></a>
                    <a href="https://play.google.com/store/apps/details?id=jp.co.ncbank.bankingappli&referrer=utm_source%3DtenpoatmH%26utm_campaign%3DtenpoatmHP"><img src="../assets/images/top/googleplay-qr.svg"></a>
                  </p>
                </div>
              </div>
              <div class="dl_info">
                <p>・Apple、Appleのロゴ、App Storeは、米国および他国のApple Inc.の登録商標です。</p>
                <p>・Google Play 、および Google Play ロゴは、Google LLC の商標です。</p>
                <p>・QRコードは（株）デンソーウェーブの登録商標です。</p>
              </div>
          </div>
          <div class="pc_none download-sp">
            <img class="banner" src="../assets/images/top/bn-area-sp.svg">
            <div class="store_link">
              <div class="app" >
                <p >iPhoneの方</p>
                <a href="https://apps.apple.com/app/apple-store/id969507478?pt=117693501&ct=tenpoatmHP_tenpoatmHP&mt=8">
                  <img src="../assets/images/top/appstore-sp.svg">
                </a>
              </div>
              <div class="android" >
                <p >Androidの方</p>
                <a href="https://play.google.com/store/apps/details?id=jp.co.ncbank.bankingappli&referrer=utm_source%3DtenpoatmH%26utm_campaign%3DtenpoatmHP">
                  <img src="../assets/images/top/googleplay-sp.svg">
                </a>
              </div>
            
            </div>
            <div class="dl_info">
              <p>・Apple、Appleのロゴ、App Storeは、米国および他国のApple Inc.の登録商標です。</p>
              <p>・Google Play 、および Google Play ロゴは、Google LLC の商標です。</p>
              <p>・QRコードは（株）デンソーウェーブの登録商標です。</p>
            </div>
          </div>
        </div>

        <BreadCrumb :crumbPages="pages"></BreadCrumb>

        <Footer></Footer>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import BreadCrumb from './partial/breadCrumb.vue';
import Header from './partial/header.vue';
import Footer from './partial/footer.vue';
import Suggest from './partial/suggestInput.vue';
import store from '../store/store';

import ApiService from '../services/api-service.js';

export default {
  name: 'Search',
  components: {
    BreadCrumb,
    Header,
    Footer,
    Suggest,
  },
  directives: {
    accordion: {
      bind: function(el) {
        el.addEventListener('click', () => {
          $('>dt', el).toggleClass('open');
          $('>dd', el).slideToggle(100);
        }, false);
      }
    }
  },
  data() {
    return {
      isPageShow: false,
      isCurrentRoute: this.$router.currentRoute.name === this.$options.name ? true : false,
      actionSheetVisible: false,
      pages: [
        {'name': 'トップ', 'url': 'https://www.ncbank.co.jp/'},
        {'name': '店舗・ATM検索', 'url': '/atm/'},
      ],
      shops: [],
      emitSuggets: [],
      emitInputName: '',
    };
  },
  computed: {
    // visibleSelectArea: function() {
    //   return store.state.showSelectArea;
    // },
    // visibleGrepFilter: function() {
    //   return store.state.showGrepFilter;
    // },
    isMobile: function() {
      return store.state.isMobile;
    },
    excel: function() {
      return store.state.excel;
    }
  },
  watch: {
  },
  methods: {
    /**
     * エリア検索画面へ遷移します
     */
    pushSerchArea() {
      if (this.isMobile) {
        this.$router.push({name: 'SelectArea', params: {animation: 'slide'}});
      } else {
        store.dispatch('updateShowSelectAreaDialog', true);
      }
    },
    /**
     * 地図画面へ遷移します
     */
    pushMap(mode) {
      //過去の検索状況を初期化
      this.shops= [];
      this.emitSuggets= [];
      this.emitInputName= '';
      navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        const param = {
          'mode': mode,
          'latitude': lat,
          'longitude': lon
        }

        ApiService.position(param)
          .then(data => {
            const ids = data.info;
            const text ='現在地から探す';
            const typeParam = {
              'type': 'gps',
              'text': text
            }
            store.dispatch('updateSearchType', typeParam);
            store.dispatch('updateResult', ids);
            
            this.$router.push({name: 'Map', params: {animation: 'slide'}});
          }, error => {
            console.log(error);
          });
      }, error => {
        console.log(error);
        this.$ons.notification.alert({
          'title': '',
          'messageHTML': `位置情報が無効になっています。`
        });
      }, {
        enableHighAccuracy: true,
      });
    },
    /**
     * 条件絞り込み画面へ遷移します
     */
    liftGrepSearch() {
      if (this.isMobile) {
        this.$router.push({name: 'GrepFilter', params: {animation: 'lift'}});
      } else {
        store.dispatch('updateShowGrepFilterDialog', true);
      }
    },
    /**
     * 条件絞り込み画面を閉じます
     */
    closePage() {
      this.actionSheetVisible = false;
    },
    /**
     * 子コンポーネントからサジェストを受け取ります
     */
    getSuggests(event) {
      this.emitSuggets = [];
      this.emitSuggets = event;
    },
    /**
     * 子コンポーネントから入力値を受け取ります
     */
    getInputName(event) {
      this.emitInputName = '';
      this.emitInputName = event;
    },
    /**
     * 受け取ったサジェストを条件に地図画面へ遷移します
     */
    pushSearchResultMap() {
      if (!_.isEmpty( this.emitInputName)) {
        const ids_org = _.map(this.emitSuggets, 'id');
        let ids=_.clone(ids_org)
        console.log(this.emitInputName)
        store.dispatch('updateInputName', this.emitInputName);
        if(this.emitInputName==="天神"){
          ids=ids_org.filter((d)=>d!="1344"&&d!="244");
        }else if(this.emitInputName==="博多"){
          ids=ids_org.filter((d)=>d!="481");
        }
        const typeParam = {
          'type': 'filter',
          'text': this.emitInputName
        }
        store.dispatch('updateSearchType', typeParam);
        store.dispatch('updateResult', ids);

        this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
      }
    },
  },
  created: function() {
    console.log("search")
  },
  mounted: function() {
    setTimeout(() => {
      this.isPageShow = true;
    }, 0);
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/search.scss";
</style>